/**
 * Register the production service worker.
 * Workbox `skipWaiting` lets a deploy's new worker activate. `clientsClaim`
 * stays off so claiming does not abort in-flight `/api/` fetches (Firefox
 * NS_BINDING_ABORTED). Auth bootstrap still times out if a fetch never settles.
 * No-op in Vitest / when SW is unsupported.
 * Uses dynamic import so unit tests never load `virtual:pwa-register`.
 */
export function registerProductionServiceWorker(): void {
  if (typeof window === "undefined") {
    return;
  }
  if (!("serviceWorker" in navigator)) {
    return;
  }
  if (import.meta.env.MODE === "test") {
    return;
  }

  void import("virtual:pwa-register").then(({ registerSW }) => {
    registerSW({
      immediate: true,
      onRegisteredSW(_swUrl, registration) {
        if (!registration) {
          return;
        }
        const hourMs = 60 * 60 * 1000;
        window.setInterval(() => {
          void registration.update();
        }, hourMs);
      },
    });
  });
}
